import {FAILURE, PENDING, SUCCESS} from '../constants'

export const UP_FAILURE = `GET_USER_PERMISSION_${FAILURE}`
export const UP_PENDING = `GET_USER_PERMISSION_${PENDING}`
export const UP_SUCCESS = `GET_USER_PERMISSION_${SUCCESS}`
